import { ObservableFromFetch } from "../ObservableFromFetch"
import RegulatoryMode from "./Model/RegulatoryMode"

export default function InsertRegulatoryModeDonor(regMode: RegulatoryMode) {
    const requestBody = JSON.stringify(regMode)
    return ObservableFromFetch<string>("FFOrderRegulatoryModeDonor/InsertRegulatoryModeDonor", requestBody)
}